<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_SUMMARY_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content" id="printSummarySectionId">
                <h3>{{ 'REQUEST_SUMMARY_REFERENCE_NUM' | translate }} {{ referenceNumber }}
                    <span style="float:right;" class="fa-solid fa-print" (click)="print()"></span>
                </h3>
                <p class="subtitle">{{ 'REQUEST_LEASE_TRANSFER_SUMMARY_NOTE' | translate }}</p>
                <h3>{{ 'REQUEST_LEASE_TRANSFER_SUMMARY_NOTE_2' | translate }}</h3>
                <table id="dataTable">
                    <tbody>
                        <tr>
                            <td>{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_NAME' | translate }}</td>
                            <td style="white-space: pre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ summary.customerName }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_LEASE_NUMBER' | translate }}</td>
                            <td style="white-space: pre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ summary.leaseNumber }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_NAME' | translate }}</td>
                            <td style="white-space: pre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ summary.dealerName }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_ADDRESS' | translate }}</td>
                            <td style="white-space: pre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ summary.dealerAddress }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_PHONE' | translate }}</td>
                            <td style="white-space: pre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>{{ summary.dealerPhone }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>